var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_404 page"},[_c('img',{staticClass:"_404_img",attrs:{"src":_vm.imgError}}),_vm._m(0),_c('PCopyright',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-bd"},[_c('p',{staticClass:"_404-label"},[_vm._v("您访问了一个不存在的页面")]),_c('p',{staticClass:"_404-label-secondary"},[_vm._v("请核实您的访问地址")])])
}]

export { render, staticRenderFns }